import { sortArray } from "components/results/analysis-results/sortUtil";
import text from "components/results/analysis-results/text";
import {
  AnalysisItem,
  GroupTableType,
  LayerGroupType,
  LegendItem,
  RV
} from "helpers/models";
import transformAnalysis from "report/common/analysis";
import combine from "report/common/combine";
import page from "report/common/page";
import transformRule from "report/common/rule";
import pageEchart from "../page/page";

export default async (
  t: any,
  analysisItems: AnalysisItem[],
  legendItems: LegendItem[]
) => {
  const grouped = transformAnalysis(analysisItems);

  const arr = ["Outside", "No Data", "Negligible", "No Observation"]; //澳大利亚，野火
  const layerIdArray = [
    "DR_Subsidence_France_SwissRe",
    "WF_DistToBush_AUS_SwissRe"
  ];

  const idArray = Object.keys(grouped).filter((key) => {
    const values = Object.keys(grouped[key]);
    if (layerIdArray.includes(key)) {
      return values.length === 1 && arr.includes(values[0]);
    }
    return values.every((value) => value === "No Data");
  });

  const { data } = Object.keys(grouped).reduce(
    (result, key) => {
      // if (!idArray.includes(key) && !key.includes("Fathom")) {
      if (!idArray.includes(key)) {
        result.data[key] = grouped[key];
      }
      return result;
    },
    { data: {} as RV }
  );

  const legend: LayerGroupType = transformRule(legendItems);

  const together: GroupTableType = combine(data, legend);

  const sorted = Object.entries(together)
    .sort(([a], [b]) => {
      return sortArray.indexOf(a) - sortArray.indexOf(b);
    })
    .reduce((acc: GroupTableType, [key, val]) => {
      acc[key] = val;
      return acc;
    }, {});

  const pageEchartArray = await pageEchart(
    t,
    sorted,
    t("report.Number of Locations")
  );

  idArray.sort((a, b) => {
    return sortArray.indexOf(a) - sortArray.indexOf(b);
  });

  const idText = text(t, idArray);

  pageEchartArray.push(idText);
  // pageEchartArray.push(page());

  return pageEchartArray;
};
